import { useMemo } from 'react';

import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { useSortingContext } from 'utils/contexts/sorting';

import { useQueryContext } from '../../../contexts';
import { ExtendedMessageType } from '../../../types';
import { TableColumn } from './constants';
import { MessageTypeRow } from './MessageTypeRow';
import { HeaderRow } from './HeaderRow';
import { NoMessageTypes } from './NoMessageTypes';

type MessageTypeRowsProps = { channelId: number };

const sortMessageType =
  (sortDirection: SORT_DIRECTIONS, sortBy: string) =>
  (a: ExtendedMessageType, b: ExtendedMessageType): number => {
    const direction = sortDirection === SORT_DIRECTIONS.ASCENDING ? 1 : -1;
    if (
      sortBy === TableColumn.subscriptionPolicy &&
      a.subscriptionPolicy !== b.subscriptionPolicy
    ) {
      return a.subscriptionPolicy > b.subscriptionPolicy ? direction : -1 * direction;
    }
    return a.name > b.name ? direction : -1 * direction;
  };

export const MessageTypeRows = ({ channelId }: MessageTypeRowsProps) => {
  const { messageTypes } = useQueryContext();
  const { sortBy, sortDirection } = useSortingContext();

  const channelMessageTypes = useMemo(
    () =>
      messageTypes
        .filter(({ messageChannelId }) => messageChannelId === channelId)
        .sort(sortMessageType(sortDirection, sortBy)),
    [channelId, messageTypes, sortBy, sortDirection],
  );

  if (!channelMessageTypes.length) {
    return <NoMessageTypes />;
  }

  return (
    <>
      <HeaderRow />
      {channelMessageTypes.map((messageType, index) => (
        <MessageTypeRow messageType={messageType} index={index} key={messageType.id} />
      ))}
    </>
  );
};
